
        var result = require("!!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[11].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[11].use[2]!../../../../node_modules/stylus-loader/dist/cjs.js??ruleSet[1].rules[11].use[3]!./segment-metric-overflow-tooltip.inline.styl");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    